import axios from 'axios';

const EXPORT_LABEL_CHUNK_SIZE = Number(process.env.REACT_APP_EXPORT_LABEL_CHUNK_SIZE) || 50;

export interface ExportLabelForm {
  documentIdList: {
    documentId: number
  }[]
  labelPrintType: number
  printStartPosition: number
}

export interface ExportLabelResponse {
  documentLabelFile: string
}

export interface GetItemLabelToExportResponse {
  itemLabelList: {
    documentId: number
    token: string
  }[]
}

export default {
  /**
   * ラベルをエクスポートします。
   *
   * @param form - エクスポートフォーム
   * @returns - エクスポートレスポンス
   */
  async export(form: ExportLabelForm): Promise<ExportLabelResponse> {
    const itemLabelTokenList: string[] = [];
    for (let i = 0; i < form.documentIdList.length; i += EXPORT_LABEL_CHUNK_SIZE) {
      const chunk = form.documentIdList.slice(i, i + EXPORT_LABEL_CHUNK_SIZE);
      // eslint-disable-next-line no-await-in-loop
      const res = await axios.post('/Documents/getItemLabelToExport', { documentIdList: chunk });
      const { itemLabelList } = res.data as GetItemLabelToExportResponse;
      itemLabelTokenList.push(...itemLabelList.map(({ token }) => token));
    }

    const res = await axios.post('/Documents/exportDocumentItemLabel', {
      labelPrintType: form.labelPrintType,
      printStartPosition: form.printStartPosition,
      itemLabelTokenList,
    });
    const { data } = res;
    return data;
  },
};
